import filtersCarouselList from './filtersConfiguration';
import { MINIMUM_FILTER_INVENTORY } from './constants';

export const reorderList = (tilesOrder, topBarFilterOptions, stepIndex) => {
    const ordered = [];
    tilesOrder.forEach((tile) => {
        const filter = topBarFilterOptions.find((subCatFilter) => tile === subCatFilter.id);
        const hasMinimumInventory = filter && filter.count >= MINIMUM_FILTER_INVENTORY;

        if ((filter && stepIndex === 1) || (stepIndex === 0 && hasMinimumInventory)) {
            ordered.push(filter);
        }
    });

    return ordered;
};

export const isNextFilterAvailable = (nextFilter, availableFilters) => !!availableFilters.find((el) => el.id === nextFilter.id);

export const isNextStepExists = (nextFilter, availableFilters, isNextFilterSelected) => isNextFilterAvailable(nextFilter, availableFilters) && !isNextFilterSelected;

export const findStepIndex = (filterTiles, activeFiltersKeys, topBarFilterIdList) => filterTiles.findIndex(({ id }) => !activeFiltersKeys.includes(id) && topBarFilterIdList.includes(id));

export const getFilterTilesCarousel = (subCategoryId, nestedSubCategoryId) => filtersCarouselList.find((el) => el.id === subCategoryId || el.id === nestedSubCategoryId);
